export enum PreviewEntityTypes {
    WORKFLOW = "workflow",
    VERIFICATION_SERVICE = "verification-service"
}